// extracted by mini-css-extract-plugin
export default {"display":"Events_display__9U7Db","contentContainer":"Events_contentContainer__fsCes","content":"Events_content__I77bd","content_exc":"Events_content_exc__qgrxy"};